import { CompanyType, EmployerInfoFragment, EmployerUpdate } from 'src/api';

import { FormValues } from '../types';

export const buildUpdateFnInput = (
  formValues: FormValues,
  employer: EmployerInfoFragment,
): Omit<EmployerUpdate, 'id'> => {
  const baseInput: Omit<EmployerUpdate, 'id'> = {
    controlledBy: formValues.controlledBy,
    // Reset on going standalone, so a stale flag does not re-enable payout on a later placement.
    keepOwnRevenueShare:
      formValues.controlledBy !== CompanyType.Employer && formValues.keepOwnRevenueShare,
  };

  if (formValues.controlledBy === CompanyType.Employer) {
    if (employer.peo) {
      baseInput.peo = {
        disconnect: { id: employer.peo.id },
      };
    }
    if (employer.peoPayrollProvider) {
      baseInput.peoPayrollProvider = {
        disconnect: { id: employer.peoPayrollProvider.id },
      };
    }
  }

  if (formValues.controlledBy === CompanyType.Peo && formValues.peo) {
    baseInput.peo = {
      connect: { id: formValues.peo.id },
    };

    if (employer.peoPayrollProvider) {
      baseInput.peoPayrollProvider = {
        disconnect: { id: employer.peoPayrollProvider.id },
      };
    }
  }

  if (formValues.controlledBy === CompanyType.PeoPayrollProvider && formValues.peoPayrollProvider) {
    baseInput.peoPayrollProvider = {
      connect: { id: formValues.peoPayrollProvider.id },
    };

    if (employer.peo) {
      baseInput.peo = {
        disconnect: { id: employer.peo.id },
      };
    }
  }

  return baseInput;
};
